DoctorFinder.Views.Autocomplete.ResultList = class ResultList extends Sparkle.Spotlight.ItemsList {
  constructor() {
    super(...arguments);
    this.handleChildToggle = this.handleChildToggle.bind(this);
    this.render = this.render.bind(this);
    this.setItems = this.setItems.bind(this);
    this.buildListItemGroup = this.buildListItemGroup.bind(this);
    this.showChildren = this.showChildren.bind(this);
    this.hideChildren = this.hideChildren.bind(this);
    this.getChildren = this.getChildren.bind(this);

    this.el.on("childToggle", this.handleChildToggle);
  }

  // EVENT HANDLERS

  handleChildToggle(event, item, element) {
    if (item.toggledOpen) {
      return this.showChildren(item);
    } else {
      return this.hideChildren(item);
    }
  }

  // RENDERING

  render() {
    const groupList = [];
    const groupLookup = {};
    const ungrouped = [];
    const destinationList = [];

    this.items.forEach((item) => {
      // Add the group name so we can group items
      const element = item.render().el;
      const groupName = item.data.group;

      // We will need to arrange grouped items into sublists
      if (groupName) {
        if (!groupLookup[groupName]) {
          groupLookup[groupName] = [];
          groupList.push(groupName);
        }

        return groupLookup[groupName].push(element.attr("data-group", groupName));
      } else {
        return ungrouped.push(element);
      }
    });

    // Add ungrouped items first
    if (ungrouped.length) {
      destinationList.push(this.buildListItemGroup(ungrouped));
    }

    // Arrange list items into sub lists
    groupList.forEach((groupName) => destinationList.push(this.buildListItemGroup(groupLookup[groupName], groupName)));

    this.el.empty();
    this.el.append(destinationList);

    return this;
  }

  // HELPER FUNCTIONS

  setItems(itemsData, identifier) {
    // We must ensure that we sort data within groups because the view will render it in groups, and if we want keyboard navigation to work, the index of each item must match the rendered order
    const groupOrder = {};
    itemsData.forEach((datum, index) => {
      if (groupOrder[datum.group] != null) {
        return;
      }
      return (groupOrder[`${datum.group}`] = datum.group ? index : -1);
    }); // Ensure non-grouped items are first, just as rendered

    itemsData = itemsData.sort((a, b) => {
      if (a.group === b.group) {
        return 0;
      } else if (groupOrder[`${a.group}`] < groupOrder[`${b.group}`]) {
        return -1;
      } else {
        return 1;
      }
    });

    return super.setItems(itemsData, identifier);
  }

  // PRIVATE

  buildListItemGroup(elements, groupName) {
    const itemGroup = jQuery("<li>", { class: "spotlight-items-list-group", role: "listitem" });
    const sublist = jQuery("<ul>", { class: "spotlight-items-list-item-container", role: "listbox" }).append(elements);
    itemGroup.append(sublist);

    if (groupName != null) {
      sublist.attr("data-group", groupName);
      itemGroup.prepend(jQuery("<span>", { class: "spotlight-items-list-group-name" }).text(groupName));
    }

    return itemGroup;
  }

  showChildren(item) {
    return this.getChildren(item).show();
  }

  hideChildren(item) {
    return this.getChildren(item).hide();
  }

  getChildren(item) {
    return item.el.nextUntil(":not([data-parent=" + item.data.value + "])");
  }
};
DoctorFinder.Views.Autocomplete.ResultList.prototype.tag = "ul";
